export type CourseProviderId =
  | 'tl'
  | 'tl-pwc'
  | 'tl-google'
  | 'semi-silicon-school'
  | 'tl-aws'
  | 'google'
  | 'aws'

export const courseProviders: {
  title: string
  id: CourseProviderId
}[] = [
  {
    title: 'TalentLabs',
    id: 'tl'
  },
  {
    title: 'PwC & TalentLabs',
    id: 'tl-pwc'
  },
  {
    title: 'AWS & TalentLabs',
    id: 'tl-aws'
  },
  {
    title: 'AWS',
    id: 'aws'
  },
  {
    title: 'Google & TalentLabs',
    id: 'tl-google'
  },
  {
    title: 'Google',
    id: 'google'
  },
  {
    title: 'Semi & Silicon School',
    id: 'semi-silicon-school'
  }
]
